enum Colors {
  Introvert = "#CFBCFF",
  Extrovert = "#4F378A",
  Blue = "#022E64",
  Gold = "#D6C104",
  Green = "#005200",
  Orange = "#D4340C",
}

export enum PersonalityType {
  IntrovertGreenGold = "IntrovertGreenGold",
  ExtrovertGreenGold = "ExtrovertGreenGold",
  IntrovertGoldGreen = "IntrovertGoldGreen",
  ExtrovertGoldGreen = "ExtrovertGoldGreen",
  IntrovertBlueGold = "IntrovertBlueGold",
  ExtrovertBlueGold = "ExtrovertBlueGold",
  IntrovertGoldBlue = "IntrovertGoldBlue",
  ExtrovertGoldBlue = "ExtrovertGoldBlue",
  IntrovertGreenOrange = "IntrovertGreenOrange",
  ExtrovertGreenOrange = "ExtrovertGreenOrange",
  IntrovertOrangeGreen = "IntrovertOrangeGreen",
  ExtrovertOrangeGreen = "ExtrovertOrangeGreen",
  IntrovertBlueOrange = "IntrovertBlueOrange",
  ExtrovertBlueOrange = "ExtrovertBlueOrange",
  IntrovertOrangeBlue = "IntrovertOrangeBlue",
  ExtrovertOrangeBlue = "ExtrovertOrangeBlue",
}

export const quizQuestions = [
  "Policies should be...",
  "When I make decisions I...",
  "When I have a choice to make I...",
  "Between these two things I am most stressed by...",
  "Between these two things I am most stressed by...",
  "Between these two things I am most stressed by...",
  "Between these two things I am most stressed by...",
  "When I'm frustrated, most often I need...",
  "When I'm frustrated, most often I need...",
  "When I'm upset, most often I need...",
  "When I'm upset, most often I need...",
  "When I'm frustrated, most often I need...",
  "When I'm frustrated, most often I need...",
  "When I'm upset, most often I need...",
  "When I'm upset, most often I need...",
];

export const quizAnswers = [
  [
    { id: "a", text: "Predictable and consistent so they can be relied upon." },
    { id: "b", text: "Flexible and adaptable so they can fit the situation." },
  ],
  [
    {
      id: "c",
      text: "Logically analyze all perspectives including my feelings.",
    },
    { id: "d", text: "Trust my gut feelings, see if it's logical." },
  ],
  [
    {
      id: "e",
      text: "Logically analyze all perspectives including my feelings.",
    },
    { id: "f", text: "Go with my gut, then try to see if it's logical." },
  ],
  [
    { id: "g", text: "People who make illogical decisions." },
    { id: "h", text: "People who are inconsistent and unpredictable." },
  ],
  [
    { id: "i", text: "Mean people and conflict." },
    { id: "j", text: "People who don't follow through and break promises." },
  ],
  [
    { id: "k", text: "People who make illogical choices." },
    { id: "l", text: "Inefficiency or things that stop my progress." },
  ],
  [
    { id: "m", text: "People who are just mean and cause conflict." },
    { id: "n", text: "Inefficiency and people or kids who move to slow." },
  ],
  [
    {
      id: "o",
      text: "Time alone to process my thoughts and what went wrong before I can talk about it.",
    },
    {
      id: "p",
      text: "Time to talk it out and to think it through with a person I respect.",
    },
  ],
  [
    {
      id: "q",
      text: "Time alone to process my thoughts about what didn't go the way I'd planned.",
    },
    {
      id: "r",
      text: "Time to talk it out while I think it through with a person I respect.",
    },
  ],
  [
    {
      id: "s",
      text: "Time alone to process my feelings about what went wrong or didn't work.",
    },
    {
      id: "t",
      text: "Time to talk it out with a person I can trust and that will understand.",
    },
  ],
  [
    {
      id: "u",
      text: "Time alone to process my feelings about what didn't go the way I planned.",
    },
    { id: "v", text: "Time to talk it out with person I trust." },
  ],
  [
    {
      id: "w",
      text: "Time alone to problem solve and decide what I will do next.",
    },
    { id: "x", text: "Time to talk it out with a person I respect." },
  ],
  [
    { id: "y", text: "A quiet minute to decide what I will do next." },
    { id: "z", text: "A minute to vent out loud and then move on." },
  ],
  [
    { id: "aa", text: "Time alone to process my feelings." },
    { id: "bb", text: "Time to talk to a person I feel will understand." },
  ],
  [
    { id: "cc", text: "Time alone to process my frustrations and feelings." },
    { id: "dd", text: "Time to talk to a person I feel will get it." },
  ],
];

export const quizStepMap: Record<string, number> = {
  a: 1,
  b: 2,
  ac: 3,
  ad: 4,
  be: 5,
  bf: 6,
  acg: 7,
  ach: 8,
  adi: 9,
  adj: 10,
  bek: 11,
  bel: 12,
  bfm: 13,
  bfn: 14,
};

export const quizResultMap: Record<string, PersonalityType> = {
  acgo: PersonalityType.IntrovertGreenGold,
  acgp: PersonalityType.ExtrovertGreenGold,
  achq: PersonalityType.IntrovertGoldGreen,
  achr: PersonalityType.ExtrovertGoldGreen,
  adis: PersonalityType.IntrovertBlueGold,
  adit: PersonalityType.ExtrovertBlueGold,
  adju: PersonalityType.IntrovertGoldBlue,
  adjv: PersonalityType.ExtrovertGoldBlue,
  bekw: PersonalityType.IntrovertGreenOrange,
  bekx: PersonalityType.ExtrovertGreenOrange,
  bely: PersonalityType.IntrovertOrangeGreen,
  belz: PersonalityType.ExtrovertOrangeGreen,
  bfmaa: PersonalityType.IntrovertBlueOrange,
  bfmbb: PersonalityType.ExtrovertBlueOrange,
  bfncc: PersonalityType.IntrovertOrangeBlue,
  bfndd: PersonalityType.ExtrovertOrangeBlue,
};

export const quizColorMap: Record<string, string[]> = {
  [PersonalityType.IntrovertGreenGold]: [
    Colors.Introvert,
    Colors.Green,
    Colors.Gold,
  ],
  [PersonalityType.ExtrovertGreenGold]: [
    Colors.Extrovert,
    Colors.Green,
    Colors.Gold,
  ],
  [PersonalityType.IntrovertGoldGreen]: [
    Colors.Introvert,
    Colors.Gold,
    Colors.Green,
  ],
  [PersonalityType.ExtrovertGoldGreen]: [
    Colors.Extrovert,
    Colors.Gold,
    Colors.Green,
  ],
  [PersonalityType.IntrovertBlueGold]: [
    Colors.Introvert,
    Colors.Blue,
    Colors.Gold,
  ],
  [PersonalityType.ExtrovertBlueGold]: [
    Colors.Extrovert,
    Colors.Blue,
    Colors.Gold,
  ],
  [PersonalityType.IntrovertGoldBlue]: [
    Colors.Introvert,
    Colors.Gold,
    Colors.Blue,
  ],
  [PersonalityType.ExtrovertGoldBlue]: [
    Colors.Extrovert,
    Colors.Gold,
    Colors.Blue,
  ],
  [PersonalityType.IntrovertGreenOrange]: [
    Colors.Introvert,
    Colors.Green,
    Colors.Orange,
  ],
  [PersonalityType.ExtrovertGreenOrange]: [
    Colors.Extrovert,
    Colors.Green,
    Colors.Orange,
  ],
  [PersonalityType.IntrovertOrangeGreen]: [
    Colors.Introvert,
    Colors.Orange,
    Colors.Green,
  ],
  [PersonalityType.ExtrovertOrangeGreen]: [
    Colors.Extrovert,
    Colors.Orange,
    Colors.Green,
  ],
  [PersonalityType.IntrovertBlueOrange]: [
    Colors.Introvert,
    Colors.Blue,
    Colors.Orange,
  ],
  [PersonalityType.ExtrovertBlueOrange]: [
    Colors.Extrovert,
    Colors.Blue,
    Colors.Orange,
  ],
  [PersonalityType.IntrovertOrangeBlue]: [
    Colors.Introvert,
    Colors.Orange,
    Colors.Blue,
  ],
  [PersonalityType.ExtrovertOrangeBlue]: [
    Colors.Extrovert,
    Colors.Orange,
    Colors.Blue,
  ],
};

export const quizColorTextMap: Record<string, string> = {
  [Colors.Introvert]: "Introvert",
  [Colors.Extrovert]: "Extrovert",
  [Colors.Blue]: "Blue",
  [Colors.Gold]: "Gold",
  [Colors.Green]: "Green",
  [Colors.Orange]: "Orange",
};

export const quizDescriptionMap = {
  [PersonalityType.IntrovertGreenGold]:
    "I am reserved and I tend to  appear aloof or detached. My metal energy is focused on processing my ideas not on talking. I use logic and past learning experiences to solve problems. I am calm when things remain orderly and rational. People who don't use their common sense irritate me. I am stressed by chaotic situations and disorganization.",
  [PersonalityType.ExtrovertGreenGold]:
    "I can be talkative or reserved, it depends on my interest level in the topic. My mental energy is focused outward on my environment as I process my ideas. I use logic and past learning experiences to solve problems. I am calm when things remain orderly and rational. People who don't use common sense irritate me. I am stressed by chaos and disorganization.",
  [PersonalityType.IntrovertGoldGreen]:
    "I am reserved but I will adopt a direct tone and take charge when necessary. My mental energy is focused inward as I work to execute my plan. I am calm when things are organized and everyone pulls their weight. Irresponsible and unpredictable people irritate me. I get stressed when the plan falls apart or when people do not follow through on their promises.",
  [PersonalityType.ExtrovertGoldGreen]:
    "I am a direct, honest communicator and a natural leader. My mental energy is focused outward as I set expectations and execute my plan. I am calm when things are organized and everyone pulls their weight. Irresponsible and unpredictable people irritate me. I get stressed when the plan falls apart or when people do not follow through on their promises.",
  [PersonalityType.IntrovertBlueGold]:
    "I am a kind, yet reserved  communicator. My mental energy is focused inward on my feelings about the goals and agendas I have set for myself. I am intuitive and caring. I am at peace when the people I care about are happy and when my work has purpose. Critical, insensitive people upset me. I am stressed by conflict, plans that fall apart, and letting people down.",
  [PersonalityType.ExtrovertBlueGold]:
    "I am an engaging, warm  communicator. My mental energy is focused outward on those around me as I work to achieve my goals. I am intuitive and caring. I am at peace when the people I care about are happy and when my work has purpose. Critical, insensitive people upset me. I am stressed by conflict, plans that fall apart, and letting people down.",
  [PersonalityType.IntrovertGoldBlue]:
    "Introvert Gold Blues are kind, dependable, and careful. They enjoy helping others and often remember small details that make people feel special. They like routines and clear plans. Introvert Gold Blues get stressed by sudden changes, too much conflict, or feeling unappreciated. When stressed, they may become quiet, overly worried, or try too hard to please everyone. They think about how to care for others and want to do things the right way. Introvert Gold Blues value harmony, tradition, and being useful to their team. As an interior designer, they focus on comfort, beauty, and function - creating warm, inviting spaces that reflect their clients' needs and personal style.",
  [PersonalityType.ExtrovertGoldBlue]:
    "I am a polite, engaging  communicator and a natural leader. My mental energy is focused outward on those around me as I execute my plan. I am calm when things are organized and everyone is working together. Irresponsible or unkind people upset me. I get stressed when my plan falls apart, when people are unhelpful or when I have conflicting agendas.",
  [PersonalityType.IntrovertGreenOrange]:
    "I am reserved and I often  appear preoccupied. My metal energy is focused inward but I will ramble about my ideas with people I trust. I use logic and my past learning experiences to solve problems. I prefer to work independently and in solitude. Illogical people who slow me down irritate me. I am stressed when I make mistakes or look dumb in front of other people. ",
  [PersonalityType.ExtrovertGreenOrange]:
    "I can be chatty or reserved, it depends on my interest level in the topic. I focus my mental energy outward as I process my ideas. I use logic and my past learning experiences to solve problems. I work independently and on my own timeline. Illogical people who slow me down irritate me. I am stressed when I make mistakes or look dumb in front of other people.",
  [PersonalityType.IntrovertOrangeGreen]:
    "I come across as reserved and preoccupied, but I am chatty with people I enjoy. My mental energy is focused inward as I multitask my way through the day. I keep my plans flexible and I am highly efficient. People who slow me down or are overly emotional irritate me. I get stressed when I am forced to be inefficient or when I am expected to follow stupid rules. ",
  [PersonalityType.ExtrovertOrangeGreen]:
    "I am a bold, direct communicator. My mental energy is focused outward and I appear to be in constant motion as I multitask. I keep my plans flexible and I am highly efficient. People who slow me down and people who are overly emotional irritate me. I get stressed when I am forced to be inefficient or when I am expected to follow stupid rules. ",
  [PersonalityType.IntrovertBlueOrange]:
    "I am a gentle, thoughtful  communicator. My mental energy is focused inward on my ideas and feelings about the things I care deeply about. I am calm when I am allowed to work independently in a peaceful environment. Controlling, insensitive people upset me. I become stressed when someone imposes on my personal time or personal space.",
  [PersonalityType.ExtrovertBlueOrange]:
    "I am a warm, engaging   communicator. My mental energy is focused outward on the people and projects I care deeply about. I am calm when I am able to work independently in a peaceful environment. Controlling or insensitive people upset me. I get stressed when there is conflict or when I feel pulled in too many directions and I have to let someone down.",
  [PersonalityType.IntrovertOrangeBlue]:
    "I am a charming, engaging  communicator. My mental energy is focused inward as I multitask my way through my day. I am calm when I am allowed to work independently and efficiently. I am laid back and light hearted. Controlling, insensitive people upset me. I get stressed when a demanding person imposes their timeline or agenda on me.",
  [PersonalityType.ExtrovertOrangeBlue]:
    "I am a charming, lively  communicator. My mental energy is focused outward as I multitask. My actions appear chaotic to others but I am efficient and I work best on my own timeline. I am laid back and light hearted. Controlling, insensitive people upset me. I get stressed when a demanding person imposes their timeline or agenda on me.",
};

export const personalityCommunicationMap: Record<PersonalityType, string> = {
  [PersonalityType.IntrovertGoldBlue]:
    "An Introvert Gold Blue interior designer is calm, polite, and listens closely to what others want. They don't talk over people or try to steal the spotlight. Instead, they ask gentle questions and pay attention to small details. They might not speak up right away, but when they do, their ideas are thoughtful and caring. Clients often feel safe talking to them about what they really want because these designers are kind and respectful and always try to avoid conflict.",
  [PersonalityType.IntrovertGoldGreen]:
    "An Introvert Gold Green interior designer is clear, direct, and focused in their communication. They speak with purpose and don't waste words. They like to talk about facts, timelines, and what needs to be done. They may not share, or focus on feelings often, but they're respectful and professional. Others can count on them to give honest updates and keep everyone on track. They listen well but expect others to be just as clear and dependable in return.",
  [PersonalityType.ExtrovertGoldBlue]:
    "An Extrovert Gold Blue interior designer is friendly, talkative, and great at working with people. They ask lots of questions to understand what the client wants and make sure everyone feels heard. They smile often, give compliments, and check in with team members. Their warm and caring words help keep the group happy and connected. They enjoy group chats and are quick to respond, helping everyone feel included and important during the project.",
  [PersonalityType.ExtrovertGoldGreen]:
    "An Extrovert Gold Green interior designer is confident, clear, and to the point. They speak up quickly in meetings and expect others to be just as direct. They focus on facts, goals, and results. When talking to clients or team members, they give strong guidance and expect quick decisions. They don't like small talk or unclear answers. Instead, they use communication to move the project forward and make sure everyone knows their role and the next step.",
  [PersonalityType.ExtrovertOrangeBlue]:
    "An Extrovert Orange Blue interior designer is lively, warm, and full of energy. They love talking with clients, listening to their dreams, and getting excited about ideas. They use playful words, bright smiles, and body language to keep the mood fun. They're great at sharing their vision out loud and cheering others on. Their upbeat communication style helps the whole others feel excited, included, and ready to work together with joy and creativity.",
  [PersonalityType.ExtrovertOrangeGreen]:
    "An Extrovert Orange Green interior designer is bold, fast-talking, and full of confidence. They enjoy jumping into new projects and bringing excitement to any conversation. They explain ideas clearly and with enthusiasm, using hands-on examples or quick sketches. They don't like slow or overly detailed talk, they prefer to get to the point. Their energy grabs attention, and they often help move decisions forward when others get stuck. Most people enjoy their charm and direct, no-nonsense communication style.",
  [PersonalityType.IntrovertOrangeBlue]:
    "An Introvert Orange Blue interior designer is quiet, kind, and gentle when they speak. They prefer one-on-one conversations over big group talks. They listen closely and notice the little things others might miss. They often show their ideas through sketches or mood boards instead of long explanations. Even though they don't talk a lot, their words are thoughtful and caring. Their calm and respectful communication helps others feel safe, seen, and understood during the project.",
  [PersonalityType.IntrovertOrangeGreen]:
    "An Introvert Orange Green interior designer is quiet, clear, and to the point. They don't use fancy words or talk just to fill the silence. Instead, they speak when they have something useful to say. They prefer quick updates and simple facts. They often show their ideas through sketches or hands-on models. Their calm, no-drama style helps the team stay focused and get things done without wasting time on unnecessary conversations or emotions.",
  [PersonalityType.ExtrovertBlueGold]:
    "An Extrovert Blue Gold interior designer is warm, expressive, and full of encouragement. They enjoy talking with clients and teammates, making sure everyone feels heard and included. They ask thoughtful questions and explain their ideas clearly, often with excitement and a big smile. They're great at reading the room and adjusting their tone to keep the group feeling positive. Their words are kind and inspiring, helping others stay motivated and focused during the project.",
  [PersonalityType.ExtrovertBlueOrange]:
    "An Extrovert Blue Orange interior designer is cheerful, expressive, and full of ideas. They love sharing their thoughts and hearing new ones from others. They use illustrative words, hand gestures, sketches, and excitement to explain their vision. They're great at making people feel important and included. Their playful and curious way of speaking brings energy to any conversation or brainstorming meeting. Even when things get busy, they find ways to keep conversations fun, creative, and full of possibility.",
  [PersonalityType.IntrovertBlueGold]:
    "An Introvert Blue Gold interior designer is calm, thoughtful, and gentle when they speak. They choose their words carefully and prefer deep, one-on-one talks over large group chats. They often listen more than they talk, but when they share, their words have meaning and insight. They care deeply about how others feel and try to create harmony. Their quiet confidence and careful communication help people feel safe, respected, and truly heard during the project.",
  [PersonalityType.IntrovertBlueOrange]:
    "An Introvert Blue Orange interior designer is gentle, creative, and thoughtful when they talk. They enjoy deep, meaningful conversations and want to understand what others truly need. They may be quiet at first, but their words carry heart and imagination. They often use stories, colors, or drawings to express their ideas. They avoid conflict and speak kindly, always trying to build understanding. Their calm and caring voice helps create a peaceful space for sharing and teamwork.",
  [PersonalityType.ExtrovertGreenOrange]:
    "An Extrovert Green Orange interior designer is talkative, quick-thinking, and full of exciting ideas. They love brainstorming out loud and bouncing ideas off others. Their energy fills the room, and they often make people laugh or think in new ways. They ask bold questions and enjoy friendly debates. They speak with passion and creativity, often using wild examples to explain their vision. Their lively communication style helps the everyone involved feel energized, curious, and open to new possibilities.",
  [PersonalityType.ExtrovertGreenGold]:
    "An Extrovert Green Gold interior designer has a bold, confident, and straight to the point communication style. They speak with strong energy and clear direction. They enjoy leading meetings, sharing big ideas, and making sure everyone stays focused. They don't waste time on small talk and expect others to be just as prepared. Their words are powerful and goal-driven, helping everyone stay on track. People listen because this designer speaks with passion, purpose, and a plan.",
  [PersonalityType.IntrovertGreenOrange]:
    "An Introvert Green Orange interior designer is quiet, thoughtful, and curious. They don't talk just to talk, but when they do, their ideas are clever and unique. They enjoy deep conversations and often surprise others with new ways of thinking. They may prefer email or sketches over talking in meetings. They listen well, ask smart questions, and bring fresh ideas that make people think. Their calm, low-pressure style helps the team slow down and think clearly.",
  [PersonalityType.IntrovertGreenGold]:
    "An Introvert Green Gold interior designer is focused, clear, and calm when they speak. They don't talk just to be friendly - they speak to share smart ideas or solve problems. They like deep, thoughtful conversations and prefer small groups or one-on-one talks. They may not show much emotion, but their words are full of purpose. They often share ideas through drawings or detailed plans. Their steady and serious communication helps the team stay clear and on task.",
};

export const personalityCommunicationHomeownerMap: Record<PersonalityType, string> = {
  [PersonalityType.IntrovertGoldBlue]:
    "During a project, an Introvert Gold Blue is kind, polite, and careful with their words. They may not speak up right away but are always paying attention. They listen closely and often remember small details others forget. Introvert Gold Blues prefer calm, one-on-one conversations over loud group talks. They avoid conflict and try to keep things peaceful. When they do speak, they are thoughtful and want to help. Their quiet, gentle voice often brings comfort and support to those around them.",
  [PersonalityType.IntrovertGoldGreen]:
    "During a project, an Introvert Gold Green is clear, direct, and to the point. They don't waste words and will speak when something needs to be said. They prefer calm, focused conversations over group chatter. Introvert Gold Greens listen well and expect others to do the same. They may not show many emotions, but they are respectful and serious about the task. If something is unclear or off-track, they will speak up to fix it and keep things moving forward.",
  [PersonalityType.ExtrovertGoldBlue]:
    "During a project, an Extrovert Gold Blue is friendly, talkative, and helpful. They like to keep everyone involved and feeling supported. They enjoy group discussions and often check in to make sure others are doing okay. Extrovert Gold Blues speak with warmth and care, and they listen closely to others' needs. They may take it personally if someone sounds upset or ignores the efforts of others. They use words to encourage others and try to make sure that everyone involved in the project stays connected and on the same page.",
  [PersonalityType.ExtrovertGoldGreen]:
    "During a project, an Extrovert Gold Green is clear, confident, and direct. They like to get straight to the point and expect others to do the same. Extrovert Gold Greens speak with purpose and don't enjoy small talk when there's work to do. They are good at giving instructions and making sure everyone knows their role. They may sound bossy at times, but their goal is to help everyone stay focused, efficient, and on track.",
  [PersonalityType.ExtrovertOrangeBlue]:
    "During a project, an Extrovert Orange Blue is energetic, friendly, and loves to connect with others. They enjoy group discussions and bring fun to the team. They're great at cheering people on and making work feel exciting. Extrovert Orange Blues speak from the heart and often use stories or humor to share ideas. They may struggle with long, serious talks, but they are great listeners when someone needs support. Their upbeat and caring style helps people feel included and encouraged.",
  [PersonalityType.ExtrovertOrangeGreen]:
    "During a project, an Extrovert Orange Green is bold, fast-talking, and full of energy. They like to speak up, share ideas quickly, and get others excited about the task. Extrovert Orange Greens are great at thinking on their feet and can explain things clearly in simple ways. They prefer action over long talks and may interrupt if things move too slowly. They enjoy working on projects with others who match their speed and efficiency. They are often the ones keeping the group awake, focused, and ready to move forward.",
  [PersonalityType.IntrovertOrangeBlue]:
    "During a project, an Introvert Orange Blue is quiet, thoughtful, and jumps in to get things going. They may not speak up right away but listen carefully to what others say. They prefer one-on-one chats instead of big group talks. Introvert Orange Blues often show how they feel through actions more than words. They avoid arguments and try to keep things peaceful. When they do speak, their words are authentic and caring. Their calm style helps others feel safe, cared about, and respected.",
  [PersonalityType.IntrovertOrangeGreen]:
    "During a project, an Introvert Orange Green is quiet, but direct, and to the point. They don't say much unless it's needed, but when they do, their words are clear and practical. Introvert Orange Greens prefer action over long talks and may get bored with too many meetings. They like working alone or in small groups. They listen well and share ideas when they have something useful to add. Their calm and focused style helps the others stay grounded and avoid drama.",
  [PersonalityType.ExtrovertBlueGold]:
    "During a project, an Extrovert Blue Gold is warm, talkative, and encouraging. They enjoy bringing people together and making sure everyone feels included. Extrovert Blue Golds are good listeners and often know how others are feeling, even without words. They speak with care and try to lift up others with positive words. They enjoy group discussions and often help solve conflicts. Their friendly and focused style helps create a team where everyone feels heard, supported, and ready to work.",
  [PersonalityType.ExtrovertBlueOrange]:
    "During a project, an Extrovert Blue Orange is talkative, enthusiastic, and full of ideas. They love to brainstorm and bring energy to every conversation. Extrovert Blue Oranges enjoy connecting with people and often use humor or stories to make their points. They may jump from topic to topic, but their excitement is contagious. They listen with care and want everyone to feel heard. Their warm and open communication helps build strong relationships and keeps things lively and fun.",
  [PersonalityType.IntrovertBlueGold]:
    "During a project, an Introvert Blue Gold is calm, thoughtful, and caring in how they speak. They listen deeply and often notice how others feel, even if nothing is said. Introvert Blue Golds choose their words carefully and prefer meaningful conversations over small talk. They don't like loud or pushy communication and may stay quiet if the communication gets too intense. When they feel safe, they share deep insights that help others understand the bigger picture and move forward wisely.",
  [PersonalityType.IntrovertBlueOrange]:
    "During a project, an Introvert Blue Orange is gentle, thoughtful, and creative when they speak. They often listen more than they talk, especially at the beginning. Introvert Blue Oranges like meaningful conversations and may share deep ideas once they feel safe. They avoid conflict and speak kindly, often using stories or personal examples. Loud or pushy communication can make them feel overwhelmed. When given space and time, their words can inspire and bring warmth, understanding, and fresh ideas to the team.",
  [PersonalityType.ExtrovertGreenOrange]:
    "During a project, an Extrovert Green Orange is talkative, playful, and full of ideas. They love sharing thoughts out loud and enjoy lively discussions. Extrovert Green Oranges ask lots of questions and enjoy debating different views - not to argue, but to explore new possibilities. They may interrupt when excited, but they mean well. They're quick thinkers and love to brainstorm with others. Their energy can spark creativity in others and their words often inspire people to think in fresh, fun ways.",
  [PersonalityType.ExtrovertGreenGold]:
    "During a project, an Extrovert Green Gold is clear, confident, and direct. They speak with purpose and like to get to the point quickly. Extrovert Green Golds enjoy leading group discussions and often take charge when things need direction. They may sound abrupt and firm, but they care about helping everyone succeed. They prefer honest, no-nonsense communication and expect others to be straightforward too. Their strong voice and clear thinking helps keep the team focused, moving, and working toward the goal.",
  [PersonalityType.IntrovertGreenOrange]:
    "During a project, an Introvert Green Orange is quiet, thoughtful, and curious. They don't talk just to fill space but speak when they have something meaningful to share. Introvert Green Oranges prefer logical, unemotional conversations and likes to explore ideas. They may ask questions that seem unusual, but they're trying to understand how things work or what is needed. Group chats can be tiring, so they often prefer one-on-one talks. Though they may seem distant at first, their ideas are often smart and creative.",
  [PersonalityType.IntrovertGreenGold]:
    "During a project, an Introvert Green Gold is clear, quiet, and focused. They don't talk just to talk - they speak when they have a smart idea or a helpful plan. They like clear, logical conversations and may get frustrated with too much small talk. Introvert Green Golds often prefer written communication or one-on-one talks. Though they may seem serious, they care about doing things well. When they speak, their words are well thought out and often help the team stay on track.",
};

export const personalityCollaborationMap: Record<PersonalityType, string> = {
  [PersonalityType.IntrovertGoldBlue]:
    "This designer likes to plan carefully and avoid surprises. They keep checklists, color samples, and measurements in neat folders or digital files. They may need extra time to feel sure before making big decisions, but their choices are based on facts and past experience. They follow a steady routine and stay on schedule. Others trust them to stay organized, remember the details, and make choices that fit both the client's needs and the space.",
  [PersonalityType.IntrovertGoldGreen]:
    "This designer enjoys making well-planned choices. Before deciding anything, they gather all the facts, measurements, and budget details. They stick to rules, use tried-and-true methods and follow each step carefully. They don't like last-minute changes or messy ideas. Their work area is tidy, and their calendar is full of deadlines. They feel proud when everything is organized, the project runs smoothly, and the end result matches the plan.",
  [PersonalityType.ExtrovertGoldBlue]:
    "This designer likes structure and prefers to follow a clear plan. They enjoy making lists, setting goals, and checking things off as they go. Before making a decision, they think about how it will affect others and try to keep everyone satisfied. They care a lot about doing things 'the right way' and often use systems that have worked well in the past. They stay on top of deadlines and love a neat, welcoming workspace.",
  [PersonalityType.ExtrovertGoldGreen]:
    "This designer is highly organized and goal-driven. They like to stick to schedules, follow rules, and use proven systems. Before making a choice, they weigh the facts, check the budget, and plan how it will all get done. They enjoy setting deadlines and holding everyone accountable to meet those deadlines. Their workspace is neat, and their calendar is full. They're great at turning big ideas into clear action steps that get real results.",
  [PersonalityType.ExtrovertOrangeBlue]:
    "This designer likes to make decisions in the moment, often based on what is efficient, and on what looks and feels best. They enjoy trying new ideas and aren't afraid to change the plan if something better comes along. While they may not love strict rules, they keep things moving with strong instincts and a sharp eye for detail. They prefer flexible plans and work best when the process allows for creativity, color, and freedom of style.",
  [PersonalityType.ExtrovertOrangeGreen]:
    "This designer likes to act quickly and solve problems on the spot. They trust their efficient, logical gut and enjoy trying new things, especially when it makes the project stand out. While they may not follow a strict plan, they stay alert and adjust fast if something goes wrong. They prefer hands-on work and learning by doing. Organization might not be perfect, but they keep things moving and know exactly what needs to happen next.",
  [PersonalityType.IntrovertOrangeBlue]:
    "This designer makes choices based on how things feel and look. They trust their senses and go with what feels right in the space. They may take their time, but their decisions are often creative and deeply personal. They don't always follow a strict plan, but they stay focused and work quietly in their own way. They enjoy peaceful, beautiful workspaces where they can think clearly and express their design style with freedom.",
  [PersonalityType.IntrovertOrangeGreen]:
    "This designer enjoys solving problems in a practical way. They make decisions based on what works best in real life. They think things through quickly and fix problems as they go. Instead of using strict plans, they stay flexible and adjust when needed. Their work space may look relaxed, but they always know where things are. They trust their logical, efficient instincts.",
  [PersonalityType.ExtrovertBlueGold]:
    "The Extrovert Blue Gold designer likes to plan ahead and keep things running smoothly. When making decisions they are primarily concerned with what feels right for the circumstances while meeting the needs of all those involved. They'll often ask for input before choosing a design to make sure everyone will be happy with not only the results of the project but also the process for getting everything done. They enjoy keeping checklists, organizing schedules, and managing timelines. While they like structure, they're also flexible when needed. Their goal is to create harmony in both the project and the workspace, blending beauty with purpose.",
  [PersonalityType.ExtrovertBlueOrange]:
    "This designer makes choices based on their values and what inspires them. They like to explore many options before picking the best one. While they may not love strict plans, they're great at jumping into action when inspiration hits. Their workspace may look a little messy, but they know where everything is. They work best with flexible schedules, colorful tools, and room to change direction as new ideas come to life.",
  [PersonalityType.IntrovertBlueGold]:
    "This designer makes choices by blending creativity with a strong sense of purpose. They want each space to feel special and meaningful for the client and not just look nice. They plan ahead and think deeply before making a decision. Their work area is often calm and neatly arranged, helping them stay focused. They enjoy working alone or in quiet spaces where they can think clearly. They stick to their vision and want everything to have a deeper purpose.",
  [PersonalityType.IntrovertBlueOrange]:
    "The Introvert Blue Orange designer makes decisions based on values, meeting other's needs, and the feeling they want a space to have. They care more about meaning than rules and may take extra time to make every thing just as the client wants. They don't always follow a strict schedule, but their actions are full of purpose and always aimed at meeting the needs of the project. They work best when given some freedom and time to explore different ideas for the client. Their work space may look a little messy, they know where everything is and there is method in their madness.",
  [PersonalityType.ExtrovertGreenOrange]:
    "This designer enjoys exploring lots of options before making a choice. They often try new styles, materials, or layouts to see what works best. They don't always follow a strict plan, but they keep things moving with smart, fast decisions. Their workspace might look scattered, but it's full of inspiration. They get bored with routines, so they like flexible schedules that let them jump from one interesting idea to the next.",
  [PersonalityType.ExtrovertGreenGold]:
    "This designer is quick to make smart, well-planned decisions. They like to see the big picture and figure out the fastest, but most competent way to reach the goal. They create strong schedules and work to stick to them. They enjoy using charts, timelines, and checklists to stay in control. They don't mind taking risks if it means getting better, smarter results. Their workspace is often clean and efficient, showing how much they value order and progress.",
  [PersonalityType.IntrovertGreenOrange]:
    "The Introvert Green Orange designer likes to explore every idea before choosing the best one. They enjoy solving problems and thinking through all the details. They may change their mind if a better plan comes up. Their workspace may look a little messy, but their minds are full of organized thoughts. They don't always follow a set routine but find creative ways to get things done. They enjoy quiet time to think and design freely.",
  [PersonalityType.IntrovertGreenGold]:
    "The Introvert Green Gold designer likes to plan ahead and think things through. They make decisions based on logic, long-term goals, and what works best, not just what looks good. They enjoy working with timelines, clear steps, and detailed layouts. They may take time to research before choosing a design. Their workspace is often neat and well-planned. They don't like last-minute changes and prefer to stick to the plan once it's been carefully thought out.",
};

export const personalityCollaborationHomeownerMap: Record<PersonalityType, string> = {
  [PersonalityType.IntrovertGoldBlue]:
    "Introvert Gold Blues like to follow clear steps and finish one task before starting another. They enjoy routines and prefer when plans are made ahead of time. They make decisions by thinking about what will help others and what has worked in the past. Introvert Gold Blues like to feel prepared and don't enjoy sudden changes or surprises. Their space is usually neat and organized, and they often take care of the little things that help the whole project run smoothly.",
  [PersonalityType.IntrovertGoldGreen]:
    "Introvert Gold Greens like structure, order, and sticking to the plan. They feel most comfortable when there's a clear goal, step-by-step instructions, and enough time to do things right. They make decisions based on facts, past experience, and what works best. Sudden changes, unclear tasks, or last-minute ideas can stress them out. Introvert Gold Greens are often the ones keeping the project on track, using checklists or routines to make sure nothing is missed or forgotten.",
  [PersonalityType.ExtrovertGoldBlue]:
    "Extrovert Gold Blues prefer to plan ahead and follow clear steps. They like checklists, schedules, and knowing what's expected. They make decisions based on how it will affect the group and what is fair or kind. They often look at what worked before and use that as a guide. Last-minute changes or unclear plans can make them feel stressed. Extrovert Gold Blues are great at keeping things running smoothly and making sure no one is left out or forgotten.",
  [PersonalityType.ExtrovertGoldGreen]:
    "Extrovert Gold Greens prefer structure, rules, and routines. They like to plan ahead and follow a set schedule. They make decisions based on facts, logic, and what has worked before. They often create lists, timelines, or step-by-step plans to guide the project. Sudden changes or lack of order can be frustrating. Extrovert Gold Greens want everything to be clear, logical, and done the right way. They take pride in finishing tasks and expect others to do their part too.",
  [PersonalityType.ExtrovertOrangeBlue]:
    "Extrovert Orange Blues prefer to take action and figure things out as they go. They don't like too many rules or long-term, detailed plans. Instead, they make decisions based on what feels right in the moment. They work best when they can be flexible and creative. Detailed schedules or long planning meetings can feel overwhelming to them. Extrovert Orange Blues like hands-on tasks and enjoy seeing quick results. They focus on what's happening now and often come up with helpful, in-the-moment ideas.",
  [PersonalityType.ExtrovertOrangeGreen]:
    "Extrovert Orange Greens make decisions quickly, logically, and based on what is happening right now. They trust their gut and often choose the most practical, hands-on option. They don't enjoy too much planning or rules, preferring to stay flexible. Extrovert Orange Greens like to dive into a project and solve problems as they come. While they may not always follow a strict plan, they get things done efficiently. They enjoy variety and may lose interest if a task feels too slow, repetitive, or is lacking in a rewarding outcome.",
  [PersonalityType.IntrovertOrangeBlue]:
    "Introvert Orange Blues make decisions based on their values and what feels right to them in the moment. They like to stay flexible and take things one step at a time. Rigid plans or too many rules can feel stressful. Introvert Orange Blues may not follow the same path as others but still care deeply about doing good work. They often organize their space in a simple, personal way that makes sense to them, even if it doesn't look traditional or neat.",
  [PersonalityType.IntrovertOrangeGreen]:
    "Introvert Orange Greens make decisions based on logic and what works best right now. They don't always follow strict plans and prefer to stay flexible. They like to figure things out as they go and enjoy solving problems in the moment. Too many rules or too much planning can be limiting. Introvert Orange Greens may not always look organized, but they know where everything is and how to get things done their own way, especially when hands-on work is involved.",
  [PersonalityType.ExtrovertBlueGold]:
    "Extrovert Blue Golds like to plan ahead and stay organized. They often make to-do lists and enjoy checking things off even though they may abandon their list if they get overwhelmed or distracted. They make decisions by thinking about how their choices will affect others. They want to keep things peaceful, fair and running smoothly. Extrovert Blue Golds don't like conflict, last-minute changes or when people aren't doing their part. They prefer clear goals, set timelines, and working with people who will communicate openly but tactfully. Their natural ability to organize people and tasks makes them strong project leaders.",
  [PersonalityType.ExtrovertBlueOrange]:
    "Extrovert Blue Oranges make decisions based on their values and what feels inspiring. They prefer flexibility over strict rules and like to explore many options before choosing. While they may not always follow a step-by-step plan, they are creative and often think of new ways to solve problems. Schedules and routines can feel boring, so they work best when they have freedom to try new things. Extrovert Blue Oranges enjoy starting projects but may need help staying focused to finish.",
  [PersonalityType.IntrovertBlueGold]:
    "Introvert Blue Golds like to plan ahead and think things through. They enjoy setting goals and creating steps to reach them. When making decisions, they focus on their feelings and values concerning the situation and work hard to consider what's best for everyone. They can become stressed by sudden changes or if others don't follow through. Introvert Blue Golds stay organized in their own way and often work best in quiet, focused environments. They care about doing things with purpose, not just checking off a task list.",
  [PersonalityType.IntrovertBlueOrange]:
    "Introvert Blue Oranges make decisions based on their personal values and what feels right in their heart. They care deeply about doing the right thing for others, not just finishing a task. Introvert Blue Oranges prefer freedom and may not like strict rules or detailed plans. They like to work in their own way and at their own pace. Though their style may seem unstructured, they care about doing meaningful work and often find creative solutions others may not see right away.",
  [PersonalityType.ExtrovertGreenOrange]:
    "Extrovert Green Oranges make decisions based on logic and big-picture thinking. They like to explore many options before choosing one. They don't enjoy following strict rules and prefer to stay flexible. They may start projects with lots of energy but lose interest in the middle if things feel boring. Extrovert Green Oranges often create their own systems that make sense to them, even if others don't understand. They're good at solving problems on the fly and changing plans when needed.",
  [PersonalityType.ExtrovertGreenGold]:
    "Extrovert Green Golds make decisions quickly and based on logic. They like to plan ahead, set goals, and follow a clear path to success. They get frustrated when things are disorganized or moving too slowly. Extrovert Green Golds enjoy taking control of a situation and setting clear rules or steps for others to follow. They're good at seeing the big picture and figuring out the smartest way to get things done, even when challenges come up.",
  [PersonalityType.IntrovertGreenOrange]:
    "Introvert Green Oranges make decisions by thinking things through carefully. They like to look at all sides of a problem before picking a solution. They enjoy freedom and don't always follow a set routine. Their workspace might look messy to others, but they know where everything is. Introvert Green Oranges don't like being rushed or told exactly how to do things. They work best when they can quietly go at their own pace, do things in a way that makes sense to them, and explore new ideas as they go.",
  [PersonalityType.IntrovertGreenGold]:
    "Introvert Green Golds are strong planners. They like to think ahead, set goals, and create smart steps to get there. They make decisions based on logic and long-term results, not just feelings. They don't enjoy surprises or last-minute changes. Introvert Green Golds prefer working in quiet spaces where they can focus without distractions. Their minds are always working, and they often come up with efficient ways to do things better. They enjoy solving hard problems and thinking through every detail.",
};

export const personalityConnectionMap: Record<PersonalityType, string> = {
  [PersonalityType.IntrovertGoldBlue]:
    "Introvert Gold Blues build trust by showing they care. They remember little things about people and often help without being asked. They don't brag or take credit and they just want the team or project to succeed. They're dependable, loyal, and honest. Once they bond with someone, they're very supportive. Others learn they can count on this designer to stay kind, keep promises, and always give their best effort.",
  [PersonalityType.IntrovertGoldGreen]:
    "Introvert Gold Greens build trust by being responsible and dependable. If they say they'll do something, they do it. They are stressed by drama or laziness. They respect coworkers and clients who are serious and hardworking. They may not open up quickly, but over time, people see that they are loyal and steady. They prefer actions over words and earn trust by showing up, doing the job right, and staying reliable from start to finish.",
  [PersonalityType.ExtrovertGoldBlue]:
    "Extrovert Gold Blues build trust by being helpful, loyal, and thoughtful. They remember birthdays, bring snacks to meetings, and make sure no one feels left out. They care deeply about people's feelings and work hard to make sure others are comfortable. They're dependable and always show up ready to help and work. People trust them because they're honest, kind, and always ready to fix problems in a gentle way that keeps relationships strong.",
  [PersonalityType.ExtrovertGoldGreen]:
    "Extrovert Gold Greens earn trust by being dependable and by being a competent and strong leader. They expect hard work and follow-through from themselves and others. They also protect the team's efforts and fight for it's success. They value honesty and speak their mind, which helps others know where they stand. Though they may seem firm, they care deeply about doing what's right and makes sense. Over time, teammates respect them for being steady, fair, and committed to the project's success.",
  [PersonalityType.ExtrovertOrangeBlue]:
    "Extrovert Orange Blues build trust by being fun, caring, and dependable in action. They make people feel important and seen, whether it's a teammate or a client. Even if they get distracted sometimes, they always come back with a smile and a solution. They keep tend to keep everyone's energy high and make work feel like a celebration. Others trust them because they're real, generous, and always willing to lend a hand when needed.",
  [PersonalityType.ExtrovertOrangeGreen]:
    "Extrovert Orange Greens build trust by showing up ready to work and take action. They may not talk about feelings much, but they prove their value by doing what needs to be done. When challenges pop up, they jump in to fix them without complaining. Teammates trust their quick thinking, bold ideas, and courage to take risks. Even in stressful times, they stay cool and bring practical solutions that keep the project on track.",
  [PersonalityType.IntrovertOrangeBlue]:
    "Introvert Orange Blues build trust through kindness, patience, and reliability. They won't push others or try to lead, but they are always there to help. They care deeply about doing good work and making people happy. They don't brag, but others notice their quiet talent. When they make a promise, they keep it. Clients, contractors, and other co-workers grow to trust them because they're consistent, gentle, and always bring a caring heart to the project.",
  [PersonalityType.IntrovertOrangeGreen]:
    "Introvert Orange Greens build trust by staying calm, doing solid work, and not making a big fuss. They may not share their feelings easily, but they show up, do their part, and solve problems without being asked. They give others space and expect the same in return. Over time, clients and coworkers come to respect their steady attitude, strong work ethic, and ability to fix things quickly when challenges come up. They're easy to work with and dependable in action.",
  [PersonalityType.ExtrovertBlueGold]:
    "Extrovert Blue Golds build trust by being caring, dependable, and always thinking of others. They check in often, offer help before being asked, and go the extra mile to support their clients, coworkers, and team. People feel safe with them because they're authentic, loyal, and encouraging. They're great at smoothing over conflict and bringing everyone together. Over time, coworkers and clients grow to deeply trust them for their open heart, their people focus, and their ability to keep everyone connected.",
  [PersonalityType.ExtrovertBlueOrange]:
    "Extrovert Blue Oranges build trust by being open, kind, authentic, and full of heart. They cheer others on and always believe in the best parts of people. They're honest, caring, and full of helpful ideas. They may forget a detail here and there, but they always make it right. Clients, coworkers, and contractors come to trust their positive spirit, creative drive, and deeply caring ways for how everyone feels. They bring fun, open communication, a deep sense of collaboration, and passion to the group, making others feel seen, heard, and supported.",
  [PersonalityType.IntrovertBlueGold]:
    "Introvert Blue Golds build trust by being caring, loyal, and dependable. They remember small details about people and check in often to make sure others are doing okay. They don't like drama and work hard to keep peace on the team. Others trust them because they are honest, thoughtful, and deeply committed to doing good work. Over time, people see that the Introvert Blue Gold always gives their full heart to the project and the people around them.",
  [PersonalityType.IntrovertBlueOrange]:
    "Introvert Blue Oranges build trust by being kind, honest, and true to their word. They care deeply about people and want everyone to feel that they are heard, seen, and understood. They may not speak up often, but when they do, it's from the heart. They support others quietly and are always willing to help. Others come to trust them because they stay true to their values while they respect everyone's thoughts and feelings. They bring warmth and sincerity to every part of the project.",
  [PersonalityType.ExtrovertGreenOrange]:
    "Extrovert Green Oranges build trust by being bold, open-minded, and always ready to help solve problems. They may joke around, but they take teamwork seriously. People trust them because they bring fresh ideas, work hard under pressure, and stay upbeat even when things go wrong. They're honest, curious, and love hearing different opinions. Over time, teammates see that this designer's creativity and courage help bring great ideas to life.",
  [PersonalityType.ExtrovertGreenGold]:
    "Extrovert Green Golds build trust by showing leadership, taking charge, and getting results. They don't just talk, they also focus on getting the work done. Others tend to trust them because they are dependable, confident, and always thinking ahead. Even though they may seem serious, they truly care about success for everyone. They expect high standards and push everyone to do their best, which helps others feel strong and capable too.",
  [PersonalityType.IntrovertGreenOrange]:
    "Introvert Green Oranges build trust by being honest, fair, and full of good ideas. They may not show strong emotions, but they care about doing things right. They often help by solving tricky problems others avoid. They don't like drama or control and give others space to do their part. Over time, teammates learn they can trust this designer to bring smart solutions, respect ideas, and work quietly and effectively behind the scenes.",
  [PersonalityType.IntrovertGreenGold]:
    "Introvert Green Golds build trust by being smart, reliable, and always prepared. They may not be warm or chatty, but they show they care by doing excellent work. They don't like drama or small talk, but they respect people who are skilled and hardworking. Others trust them because they follow through, keep improving, and focus on success. Over time, people learn this designer is dependable, wise, and always working toward the best possible outcome.",
};

export const personalityConnectionHomeownerMap: Record<PersonalityType, string> = {
  [PersonalityType.IntrovertGoldBlue]:
    "Introvert Gold Blues build trust by being dependable and kind. They show up on time, do what they promise, and try to make things easier for others. They trust people who are respectful, honest, and gentle. Introvert Gold Blues don't like being the center of attention but feel good when they're appreciated. Once they trust someone, they are loyal and supportive. They may not share personal thoughts quickly, but with time, they open up and become steady, caring teammates.",
  [PersonalityType.IntrovertGoldGreen]:
    "Trust is very important to an Introvert Gold Green. They earn trust by being responsible and doing what they say they will. They trust others who are honest, hardworking, and dependable. Introvert Gold Greens may not share personal thoughts easily, but they are loyal and steady once trust is built. They don't like drama or lazy behavior. They feel most comfortable with designers or contractors who follow through, show respect, and focus on the job, just like they do.",
  [PersonalityType.ExtrovertGoldBlue]:
    "Trust is built through kindness, consistency, and teamwork. Extrovert Gold Blues show they care by being dependable and thoughtful. They trust others who are warm, honest, and follow through on promises. They like clear communication and appreciation. If trust is broken, they may feel hurt and need time to rebuild. Once trust is there, Extrovert Gold Blues are loyal, caring, and willing to go the extra mile to help those they care about. They believe good relationships make the work better.",
  [PersonalityType.ExtrovertGoldGreen]:
    "Extrovert Gold Greens build trust by being responsible, honest, logical, and hardworking. They trust people who are dependable, direct, and get the job done right. They may not be emotional or overly sensitive, but they care deeply about doing good work and helping the project move along to completion. They expect others to keep promises, follow rules, keep things logical with low drama, and to respect the plan. Once trust is earned, Extrovert Gold Greens are loyal to others and prefer to lead with strength while supporting those they work with.",
  [PersonalityType.ExtrovertOrangeBlue]:
    "Extrovert Orange Blues build trust through kindness, honesty, and shared experiences. They trust people who are warm, allow them their freedom, and who will be real with them. They enjoy working closely with others and do best in friendly, upbeat relationships. If someone is cold or too controlling, it can make them pull away. Extrovert Orange Blues may not always show it, but they care deeply about how others feel. When they feel appreciated for their unique gifts and accepted for who they are, they become joyful, loyal, and dependable project pals who give their full effort.",
  [PersonalityType.ExtrovertOrangeGreen]:
    "Extrovert Orange Greens build trust by being honest, action-focused, and reliable in the moment. They trust people who keep up with their pace and show confidence. They like working people who are innovative, real, and ready to work hard. Extrovert Orange Greens don't open up emotionally right away, but they show they care by doing things to help others. If someone is too slow or overly controlling, it may frustrate them. With trust, Extrovert Orange Greens become loyal, supportive, and fun to be with.",
  [PersonalityType.IntrovertOrangeBlue]:
    "Introvert Orange Blues build trust slowly and quietly. They trust people who are kind, honest, and don't push too hard. They show they care by being helpful and thoughtful, not by making a big deal out of things. If someone is too bossy or unkind, the Introvert Orange Blue may pull away. Once trust is built, they are devoted and supportive friends. They value being treated with respect and love working with people who are calm and caring like them.",
  [PersonalityType.IntrovertOrangeGreen]:
    "Introvert Orange Greens build trust through actions, not words. They respect people who are capable, calm, and let them work at their own pace. They don't open up quickly, but once they trust someone, they are reliable and willing to help. Introvert Orange Greens don't like being micromanaged or forced into emotional conversations. They feel most comfortable with people who give them space, stay honest, and work hard. Over time, their steady effort and helpful nature shows their loyalty.",
  [PersonalityType.ExtrovertBlueGold]:
    "Extrovert Blue Golds build trust by being caring, helpful, and dependable. They remember people's needs and check in often. They trust others who are kind, honest, and willing to work collaboratively. Extrovert Blue Golds give their best when they feel appreciated and respected. If someone is cold or unfriendly, it can hurt their feelings. But once they trust someone, they're loyal and always ready to help. They believe strong relationships make everything easier and better for everyone.",
  [PersonalityType.ExtrovertBlueOrange]:
    "Extrovert Blue Oranges build trust by being friendly, honest, and encouraging. They care about others' feelings and want people to feel supported. They trust those who are open-minded, kind, and real with them. Extrovert Blue Oranges may feel hurt if others are too cold or critical. Once trust is built, they are devoted friends, fun, and full of support. They bring warmth and passion to all their relationships and are always ready to cheer others on when things get tough.",
  [PersonalityType.IntrovertBlueGold]:
    "Introvert Blue Golds build trust slowly and quietly. They look for honesty, kindness, and dependability in others. They trust people who respect their need for space and deep thinking. If someone is fake or too harsh, they may pull away. Once trust is built, Introvert Blue Golds are loyal, supportive, and always willing to help. They remember what matters to others and show care through thoughtful actions and words. Trust helps them feel safe enough to share their full ideas and energy.",
  [PersonalityType.IntrovertBlueOrange]:
    "Introvert Blue Oranges build trust slowly, by watching how people treat others and how authentic they are. They trust people who are kind, gentle, and respectful. If someone is harsh, fake, or pushy, they may shut down or pull away. Once trust is built, Introvert Blue Oranges are devoted friends, caring, and will quietly do anything for the people they care about. They show trust through their actions and thoughtful support. They work best with people who respect their feelings and allow them to express themselves in their own way.",
  [PersonalityType.ExtrovertGreenOrange]:
    "Extrovert Green Oranges build trust through open conversation, honesty, and shared ideas. They trust people who keep up with their fast thinking and enjoy exploring new ideas. Extrovert Green Oranges may joke a lot, but they still care about doing good work and being a helpful team player. They can forget to check in emotionally, so they work best with people who remind them to slow down and connect. Once trust is built, Extrovert Green Oranges are loyal, fun, and full of creative support.",
  [PersonalityType.ExtrovertGreenGold]:
    "Extrovert Green Golds build trust through leadership, hard work, and follow-through. They trust others who are logical, responsible, honest, and focused. They may not always show their feelings, but they care deeply about results and want everyone to do their best. Extrovert Green Golds don't enjoy drama or laziness. Once trust is earned, they are loyal, protective, and supportive leaders who will push others to grow and win together. They value people who show up, speak up, and work hard.",
  [PersonalityType.IntrovertGreenOrange]:
    "Introvert Green Oranges build trust by being honest and dependable in their own quiet way. They trust people who respect their space and let them think without pressure. They may not show feelings easily, but they care deeply about doing good work. Introvert Green Oranges need time to open up, but once they do, they are loyal, helpful, and eager to share ideas. They feel safest with people who listen, are fair, and don't expect constant small talk or emotional talk.",
  [PersonalityType.IntrovertGreenGold]:
    "Introvert Green Golds build trust through competence and consistency. They trust people who are responsible, smart, and follow through on what they say. Introvert Green Golds may not open up emotionally right away, but they show trust by sharing ideas and including others in their plans. They respect people who are logical, focused, and hard-working. If someone is too emotional or disorganized, it may be hard for the Introvert Green Gold to connect. But once trust is built, they are loyal and dependable.",
};

export const personalityStrengthsMap: Record<PersonalityType, string[]> = {
  [PersonalityType.IntrovertGoldBlue]: [
    "Deep nurturing",
    "Quiet Strength",
    "Personalized care",
    "Long-term loyalty",
    "Steadfast service",
    "Emotional safety net",
    "Tradition-keeping",
    "Memory for details",
  ],
  [PersonalityType.ExtrovertBlueGold]: [
    "Brings a group together",
    "Inspires others",
    "Team builder",
    "Can read a crowd",
    "Empowers people",
    "Cares for others",
    "Mentoring mindset",
    "Builds solid relationships",
  ],
  [PersonalityType.IntrovertBlueOrange]: [
    "Cenerates 1000s of ideas",
    "Sees potential in all",
    "People magnet",
    "Contagious passion",
    "Can easily share a vision",
    "Shares hope and joy",
    "Shares positive energy",
    "Can be a change catalyst",
  ],
  [PersonalityType.ExtrovertBlueOrange]: [
    "Generates 1000s of ideas",
    "Sees the potential in all",
    "People magnet",
    "Contagious passion",
    "Can easily share a vision",
    "Spreads hope and joy",
    "Shares positive energy",
    "Can be a change catalyst",
  ],
  [PersonalityType.IntrovertGoldGreen]: [
    "Flawless execution",
    "Great memory recall",
    "Creates structure",
    "Crisis stability",
    "Procedural mastery",
    "Duty-focused action",
    "Consistency",
    "Rule implementation",
  ],
  [PersonalityType.IntrovertBlueGold]: [
    "Deep nurturing",
    "Quiet strength",
    "Personalized care",
    "Long-term loyalty",
    "Steadfast service",
    "Emotional safety net",
    "Tradition-keeping",
    "Memory for details",
  ],
  [PersonalityType.ExtrovertGoldGreen]: [
    "Tradition keeper",
    "Systems mastery",
    "Operational control",
    "Skilled leader",
    "Responsibility enforcer",
    "Standards keeper",
    "Clarity bringer",
    "Values fairness",
  ],
  [PersonalityType.ExtrovertGoldBlue]: [
    "Serves at the group's glue",
    "Protects harmony",
    "Group caretaker",
    "Expert people reader",
    "Relational leadership",
    "Tradition keeper",
    "Reliable collaborator",
    "Promotes rule following",
  ],
  [PersonalityType.IntrovertGreenGold]: [
    "Master planning",
    "Long-range vision",
    "Systems thinking",
    "Goal execution",
    "Unshakable logic",
    "Efficiency expert",
    "Pattern mastery",
    "Logical decision-making",
  ],
  [PersonalityType.IntrovertGreenOrange]: [
    "Conceptual mastery",
    "Good with abstract logic",
    "Invents working systems",
    "Theoretical visionary",
    "Detached clarity",
    "Root cause analysis",
    "Seeks truth",
    "Thinks things through",
  ],
  [PersonalityType.ExtrovertGreenGold]: [
    "Commanding leader",
    "Excels at vision execution",
    "Bold strategizing",
    "Efficient engineer",
    "Logical problem-solver",
    "Big-picture focus",
    "Works to shape the future",
    "Gets to the point quickly",
  ],
  [PersonalityType.ExtrovertGreenOrange]: [
    "Expert negotiator",
    "Debate genius",
    "Creative disruption",
    "Concept flipping",
    "Idea expansion",
    "Mental agility",
    "Pushes the limits",
    "Future-focused visionary",
  ],
  [PersonalityType.IntrovertOrangeGreen]: [
    "Tactical problem-solving",
    "Crisis response",
    "Tool mastery",
    "Cool analysis",
    "Effortless improvisation",
    "Hands-on logic",
    "Spontaneous precision",
    "Risk navigation",
  ],
  [PersonalityType.IntrovertOrangeBlue]: [
    "Emotional artistry",
    "Creative expression",
    "Capacity for inner peace",
    "In the moment focus",
    "Kindhearted action",
    "Empathic response",
    "Grace under stress",
    "Drawn to nature",
  ],
  [PersonalityType.ExtrovertOrangeGreen]: [
    "Risk precision",
    "Crisis navigation",
    "Situational command",
    "Action leadership",
    "Sensory mastery",
    "Instant reaction",
    "Bold innovation",
    "Persuasive with people",
  ],
  [PersonalityType.ExtrovertOrangeBlue]: [
    "Spreads joyfulness",
    "People energizer",
    "Experience maximizer",
    "Naturally warm with others",
    "Excels at creating an event",
    "Can read a crowd",
    "Empathy in action",
    "Optimistic spark",
  ],
};

export const personalityPerksMap: Record<PersonalityType, string[]> = {
  [PersonalityType.IntrovertGoldBlue]: [
    "Caring",
    "Reliable",
    "Thoughtful",
    "Loyal",
    "Gentle",
    "Observant",
    "Humle",
    "Patient",
  ],
  [PersonalityType.ExtrovertBlueGold]: [
    "Inspiring",
    "Warm",
    "Organized",
    "Empathetic",
    "Driven",
    "Persuasive",
    "Loyal",
    "Encouraging",
  ],
  [PersonalityType.IntrovertBlueOrange]: [
    "Enthusiastic",
    "Playful",
    "Open",
    "Curious",
    "Loving",
    "Expressive",
    "Creative",
    "Spontaneous",
  ],
  [PersonalityType.ExtrovertBlueOrange]: [
    "Enthusiastic",
    "Playful",
    "Open",
    "Curious",
    "Loving",
    "Expressive",
    "Creative",
    "Spontaneous",
  ],
  [PersonalityType.IntrovertGoldGreen]: [
    "Responsible",
    "Practical",
    "Loyal",
    "Dependable",
    "Organized",
    "Hardworking",
    "Serious",
    "Detail-oriented",
  ],
  [PersonalityType.IntrovertBlueGold]: [
    "Caring",
    "Reliable",
    "Thoughtful",
    "Loyal",
    "Gentle",
    "Observant",
    "Humble",
    "Patient",
  ],
  [PersonalityType.ExtrovertGoldGreen]: [
    "Efficient",
    "Direct",
    "Reliable",
    "Practical",
    "Assertive",
    "Organized",
    "Structured",
    "Loyal",
  ],
  [PersonalityType.ExtrovertGoldBlue]: [
    "Supportive",
    "Loyal",
    "Sociable",
    "Responsible",
    "Caring",
    "Organized",
    "Warm",
    "Helpful",
  ],
  [PersonalityType.IntrovertGreenGold]: [
    "Strategic",
    "Focused",
    "Determined",
    "Independent",
    "Logical",
    "Confident",
    "Efficient",
    "Reserved",
  ],
  [PersonalityType.IntrovertGreenOrange]: [
    "Curious",
    "Analytical",
    "Objective",
    "Inventive",
    "Independent",
    "Thoughtful",
    "Precise",
    "Quiet",
  ],
  [PersonalityType.ExtrovertGreenGold]: [
    "Assertive",
    "Driven",
    "Strategic",
    "Efficient",
    "Confident",
    "Decisive",
    "Organized",
    "Bold",
  ],
  [PersonalityType.ExtrovertGreenOrange]: [
    "Witty",
    "Inventive",
    "Expressive",
    "Curious",
    "Energetic",
    "Charming",
    "Fearless",
    "Original",
  ],
  [PersonalityType.IntrovertOrangeGreen]: [
    "Independent",
    "Calm",
    "Adaptable",
    "Practical",
    "Resourceful",
    "Logical",
    "Private",
    "Observant",
  ],
  [PersonalityType.IntrovertOrangeBlue]: [
    "Gentle",
    "Creative",
    "Warm",
    "Flexible",
    "Sensitive",
    "Quiet",
    "Kind",
    "Harmonious",
  ],
  [PersonalityType.ExtrovertOrangeGreen]: [
    "Energetic",
    "Bold",
    "Flexible",
    "Practical",
    "Confident",
    "Sociable",
    "Realistic",
    "Quick-thinking",
  ],
  [PersonalityType.ExtrovertOrangeBlue]: [
    "Fun-loving",
    "Friendly",
    "Lively",
    "Charming",
    "Spontaneous",
    "Warm",
    "Generous",
    "Tactile",
  ],
};

export const personalityPitfallsMap: Record<PersonalityType, string[]> = {
  [PersonalityType.IntrovertGoldBlue]: [
    "Overly self-sacrificing",
    "Fear of conflict",
    "Resistance to change",
    "Takes criticism personally",
    "Too focused on others",
    "Avoids confrontation",
    "Burnout risk",
    "Passive communication",
  ],
  [PersonalityType.ExtrovertBlueGold]: [
    "May become overly-involved",
    "Controlling when stressed",
    "Neglects self",
    "Avoids conflict at all costs",
    "May be too idealistic",
    "Takes on too much",
    "Emotionally over extends",
    "Rarely says no but needs to",
  ],
  [PersonalityType.IntrovertBlueOrange]: [
    "Becomes unfocused",
    "Overcommits too often",
    "May not follow-through",
    "Avoids conflict at all costs",
    "Can be overly emotional",
    "Become easily bored",
    "Can be unrealistic",
    "Seems disorganized",
  ],
  [PersonalityType.ExtrovertBlueOrange]: [
    "Becomes unfocused",
    "Overcommits too often",
    "May not follow-through",
    "Avoids conflict at all costs",
    "Can be overly emotional",
    "Become easily bored",
    "Can be unrealistic",
    "Seems disorganized",
  ],
  [PersonalityType.IntrovertGoldGreen]: [
    "May become overly rigid",
    "Can be judgmental",
    "Stressed by change",
    "Emotionally distant Workaholic tendencies",
    "Difficulty with feelings",
    "Over-focus on rules",
    "May dismiss new ideas",
  ],
  [PersonalityType.IntrovertBlueGold]: [
    "Overly self-sacrificing",
    "Fear of conflict",
    "Resistance to change",
    "Takes criticism personally",
    "Too focused on others",
    "Avoids confrontation",
    "Burnout risk",
    "Passive communication",
  ],
  [PersonalityType.ExtrovertGoldGreen]: [
    "May be bossy under stress",
    "Can seem Inflexible",
    "Becomes judgmental",
    "Dismissive of feelings",
    "Controlling when stressed",
    "May be impatient",
    "Can be overly critical",
    "Workaholic",
  ],
  [PersonalityType.ExtrovertGoldBlue]: [
    "People-pleasing",
    "Fear of rejection",
    "Overextends self",
    "Avoids conflict",
    "Overly sensitive",
    "Rigid about rules",
    "Gossipy under stress",
    "Needs constant approval",
  ],
  [PersonalityType.IntrovertGreenGold]: [
    "Emotionally detached",
    "Arrogant",
    "Overly critical",
    "Dislikes being wrong",
    "Impatient with inefficiency",
    "Too independent",
    "Dismisses emotions",
    "Perfectionist",
  ],
  [PersonalityType.IntrovertGreenOrange]: [
    "Struggles with being social",
    "Overanalyzes most things",
    "Procrastinates decisions",
    "Insensitive to emotions",
    "May dismiss traditions",
    "Can be disorganized",
    "Struggles to finish tasks",
    "Easily distracted",
  ],
  [PersonalityType.ExtrovertGreenGold]: [
    "Domineering",
    "Impatient",
    "Insensitive",
    "Overbearing",
    "Dismisses others' feelings",
    "Workaholic",
    "Blunt",
    "Struggles with vulnerability",
  ],
  [PersonalityType.ExtrovertGreenOrange]: [
    "May be argumentative",
    "Can be easily distracted",
    "May be overconfident",
    "Insensitive to emotions",
    "May ignore rules",
    "Becomes impulsive",
    "Weak on follow-through",
    "Procrastinates boring work",
  ],
  [PersonalityType.IntrovertOrangeGreen]: [
    "Can often be aloof",
    "Insensitive at times",
    "Quietly takes risks",
    "Struggles with routine",
    "Detached in relationships",
    "Avoids commitment",
    "Impatient with emotions",
    "Stressed by stupid rules",
  ],
  [PersonalityType.IntrovertOrangeBlue]: [
    "Easily hurt",
    "Avoids confrontations",
    "Unstructured organization",
    "Often procrastinates",
    "Follows feelings over logic",
    "May be hard to read",
    "Resists ridged planning",
    "May be passive with stress",
  ],
  [PersonalityType.ExtrovertOrangeGreen]: [
    "Becomes impulsive",
    "Easily bored",
    "Can be insensitive",
    "Lacks long-term planning",
    "May choose risky behavior",
    "Is often a poor listener",
    "Become impatient",
    "Disregards rules",
  ],
  [PersonalityType.ExtrovertOrangeBlue]: [
    "Often becomes distracted",
    "Avoids long-term planning",
    "Overly focused on fun",
    "May be impulsive",
    "Sensitive to criticism",
    "Struggles with structure",
    "Can be dramatic",
    "May avoid serious issues",
  ],
};

export const personalitySuperpowerMap: Record<PersonalityType, string> = {
  [PersonalityType.IntrovertGoldBlue]:
    "An Introvert Gold Blue designer is strong in teamwork, responsibility, and detail work. They create cozy, practical spaces that match what the client really needs. Their quiet focus, follow-through, and thoughtful designs make them a trusted and steady part of any interior design team.",
  [PersonalityType.IntrovertGoldGreen]:
    "Introvert Gold Greens are strong at following rules, meeting deadlines, and managing big projects step by step. They make smart, practical designs that work in real life. Their clear thinking, planning skills, and sense of duty help them create strong, well-built spaces their clients can depend on.",
  [PersonalityType.ExtrovertGoldBlue]:
    "Extrovert Gold Blues excel in supporting teamwork, planning, and customer service. They create beautiful, comfortable spaces that match what clients really want. Their kindness, strong work ethic, and attention to people's needs make them a favorite on any interior design team.",
  [PersonalityType.ExtrovertGoldGreen]:
    "Extrovert Gold Greens are strong leaders who turn ideas into action. They keep projects on time, within budget, and highly professional. Their drive, structure, and focus make them ideal for handling tough design challenges and big-picture planning.",
  [PersonalityType.ExtrovertOrangeBlue]:
    "Extrovert Orange Blue designers are naturals at turning spaces into beautiful, joyful places. They shine in client meetings, spark creative ideas, and bring energy to every step. Their passion, style, and people skills make design projects both exciting and successful.",
  [PersonalityType.ExtrovertOrangeGreen]:
    "Extrovert Orange Greens are adventurous designers who bring bold, fresh style to any space. They solve problems quickly, handle pressure with ease, and lead with action. Their energy, flexibility, and can-do perspective helps them shine in fast-paced projects that need quick thinking and strong results.",
  [PersonalityType.IntrovertOrangeBlue]:
    "Introvert Orange Blues are gifted at creating peaceful, beautiful spaces full of warmth and meaning. Their sense of style, deep focus, and kind nature help them connect with clients in a personal way. They express emotion through design and shine in quiet roles that let their creativity and care speak through their work.",
  [PersonalityType.IntrovertOrangeGreen]:
    "Introvert Orange Greens bring practical skill, creative problem-solving, and cool thinking to design work. They're great with tools, layouts, and making smart choices on the spot. Their quiet confidence and ability to fix issues fast make them a reliable and valuable part of any interior design team.",
  [PersonalityType.ExtrovertBlueGold]:
    "Extrovert Blue Golds shine as team leaders and thoughtful designers. They bring strong people skills, big-picture planning, and a gift for creating spaces that feel good to everyone. Their warmth, organization, and passion for helping others make them standout designers in both beauty and teamwork.",
  [PersonalityType.ExtrovertBlueOrange]:
    "Extrovert Blue Oranges are bursting with creativity and empathy. They dream up bold, beautiful designs and bring people together with their upbeat energy. Their strengths include idea generation, people skills, and inspiring teamwork. They're natural at turning a vision into a lively space full of meaning, color, and joy while delivering on exactly what the client wants and needs.",
  [PersonalityType.IntrovertBlueGold]:
    "Introvert Blue Golds bring vision, heart, and meaning to every design. They create beautiful, peaceful spaces that feel deeply personal to the client. Their strengths include deep caring, empathy, strong planning, and a quiet drive to make things better. They help others feel understood and bring powerful creativity to every part of the project.",
  [PersonalityType.IntrovertBlueOrange]:
    "Introvert Blue Oranges bring imagination, sensitivity, and meaning to their designs. They create cozy, artistic spaces that reflect the heart of their clients. Their strengths include being completely client focused, being emotional insightful, and having trustworthy personal values. They shine when given room to dream and help turn emotions into inspiring, beautiful design.",
  [PersonalityType.ExtrovertGreenOrange]:
    "Extrovert Green Oranges shine in fast-paced projects full of change and challenge. They bring bold ideas, creative solutions, and a fearless spirit to every design. Their strengths include flexible thinking, confidence, and great people skills. They turn big dreams into playful, stylish spaces that surprise and delight everyone involved.",
  [PersonalityType.ExtrovertGreenGold]:
    "Extrovert Green Golds are natural leaders who bring vision, structure, and determination to every design project. They keep things moving, solve problems fast, and inspire others to reach big goals. Their top strengths include strategy, leadership, planning, and pushing ideas into action with style and purpose.",
  [PersonalityType.IntrovertGreenOrange]:
    "Introvert Green Oranges bring original ideas, deep focus, and logical thinking to every design. They're great at solving tough problems and creating smart, beautiful spaces. Their strengths include independence, creativity, and careful planning. They shine when allowed to think freely and turn complex ideas into one-of-a-kind design solutions.",
  [PersonalityType.IntrovertGreenGold]:
    "Introvert Green Golds are expert planners and problem-solvers. They bring bold vision, clear structure, and high standards to every design. Their strengths include long-term thinking, creativity, independence, and a strong drive to make things better. They shine when leading big projects that need focus, smart strategy, and beautiful, lasting results.",
};

export const personalitySuperpowerHomeownerMap: Record<PersonalityType, string> = {
  [PersonalityType.IntrovertGoldBlue]:
    "Introvert Gold Blues are reliable, detail-focused, and hardworking. They are great at remembering what others need and making sure tasks are done right. Their caring nature helps everyone feel safe and supported.",
  [PersonalityType.IntrovertGoldGreen]:
    "Introvert Gold Greens are dependable, organized, and focused. They work hard, follow rules, and notice mistakes others might miss. Their steady nature helps others feel safe, prepared, and ready to succeed.",
  [PersonalityType.ExtrovertGoldBlue]:
    "Extrovert Gold Blues are organized, helpful, and caring. They are great at noticing others' needs and creating a team spirit. Their planning skills and warm attitude make them strong leaders and supporters.",
  [PersonalityType.ExtrovertGoldGreen]:
    "Extrovert Gold Greens are strong leaders who bring order, drive, and discipline to a project. They are dependable, organized, and always ready to take charge and solve problems.",
  [PersonalityType.ExtrovertOrangeBlue]:
    "Extrovert Orange Blues bring energy, creativity, and people skills to every project. They're great at lifting everyone's spirit, handling surprises, and solving problems in the moment with a smile and a quick, effective solution.",
  [PersonalityType.ExtrovertOrangeGreen]:
    "Extrovert Orange Greens bring energy, speed, and sharp thinking to any project. They're great at solving real-time problems, staying cool under pressure, and keeping things fun and moving forward.",
  [PersonalityType.IntrovertOrangeBlue]:
    "Introvert Orange Blues bring quiet creativity, gentle efficiency, and strong values to every project. They are careful, caring workers who notice small details and help others feel calm and included.",
  [PersonalityType.IntrovertOrangeGreen]:
    "Introvert Orange Greens are hands-on problem solvers who stay calm under pressure. They are great at fixing things, thinking fast, and working independently. They bring logic, skill, and quiet strength to every project.",
  [PersonalityType.ExtrovertBlueGold]:
    "Extrovert Blue Golds bring energy, organization, and heart to a project. They are natural leaders who focus on building positive relationships. They also enjoy handling details, and care deeply about others' success and well-being.",
  [PersonalityType.ExtrovertBlueOrange]:
    "Extrovert Blue Oranges are creative, caring, and great at bringing people together. They inspire others, build strong connections and and bring fresh ideas to every project.",
  [PersonalityType.IntrovertBlueGold]:
    "Introvert Blue Golds are caring, creative, and focused. They bring deep thinking, strong planning, and emotional understanding to a project. Their insight helps everyone grow, connect, and succeed together.",
  [PersonalityType.IntrovertBlueOrange]:
    "Introvert Blue Oranges bring creativity, kindness, and deep caring to any project. They care about people and purpose, and their gentle style helps create a calm, thoughtful work environment.",
  [PersonalityType.ExtrovertGreenOrange]:
    "Extrovert Green Oranges are quick thinkers, creative problem-solvers, and strong communicators. They bring energy, curiosity, and big ideas to every project and help others stay excited and open-minded.",
  [PersonalityType.ExtrovertGreenGold]:
    "Extrovert Green Golds are natural leaders who bring focus, competence, strategy, and drive to every project. They are goal-setters, problem-solvers, and strong decision-makers who lead the way to success.",
  [PersonalityType.IntrovertGreenOrange]:
    "Introvert Green Oranges are curious, logical, and great at solving problems. They bring new ideas, ask deep questions, and think outside the box. Their calm, clever thinking helps projects grow.",
  [PersonalityType.IntrovertGreenGold]:
    "Introvert Green Golds are logical, strategic, organized, and driven. They are strong leaders who plan ahead, stay focused, and solve tough problems. Their clear vision and smart ideas help projects to succeed.",
};

export const getPersonalitySurveyContent = (answers: string = "") => {
  let question = quizQuestions[answers.length];
  let options = quizAnswers[answers.length];
  let result = quizResultMap[answers];

  if (answers !== "") {
    const questionStep = quizStepMap[answers];
    question = quizQuestions[questionStep] || question;
    options = quizAnswers[questionStep] || options;
  }

  return {
    question: question ?? null,
    options: Array.isArray(options) ? options : [],
    result: result || null,
  };
};

/**
 * Get the canonical answer sequence (string path) for a given PersonalityType
 * This reverses the quizResultMap to find the answer path that leads to a specific personality type
 */
export const getAnswerPathForPersonalityType = (personalityType: PersonalityType): string | null => {
  // Find the key in quizResultMap that maps to this personality type
  for (const [answerPath, type] of Object.entries(quizResultMap)) {
    if (type === personalityType) {
      return answerPath;
    }
  }
  return null;
};
